import { useState } from "react";

import { DeliverySinksTable } from "@/components/tradeideas/delivery-sinks-table";
import { OutboxTable } from "@/components/tradeideas/outbox-table";
import {
  TradeIdeasEmpty,
  TradeIdeasError,
  TradeIdeasPage,
} from "@/components/tradeideas/tradeideas-page";
import {
  useDeleteTradeIdeasSink,
  useRetryTradeIdeasOutbox,
  useTradeIdeasOutbox,
  useTradeIdeasSinks,
  useTradeIdeasStatus,
  useUpsertTradeIdeasSink,
} from "@/hooks/tradeideas/useTradeIdeasBot";

export default function TradeIdeasDeliveryPage() {
  const [outboxStatus, setOutboxStatus] = useState("dead");
  const sinksQ = useTradeIdeasSinks();
  const statusQ = useTradeIdeasStatus();
  const outboxQ = useTradeIdeasOutbox(outboxStatus);
  const upsertSink = useUpsertTradeIdeasSink();
  const deleteSink = useDeleteTradeIdeasSink();
  const retryOutbox = useRetryTradeIdeasOutbox();
  const sinks = sinksQ.data ?? [];

  return (
    <TradeIdeasPage
      title="TradeIdeas Delivery"
      description="Runtime alert destinations for signals, data-engine, Discord, and Telegram."
    >
      {sinksQ.isError ? (
        <TradeIdeasError message={(sinksQ.error as Error).message} />
      ) : sinksQ.isLoading && sinks.length === 0 ? (
        <TradeIdeasEmpty message="Loading delivery sinks..." />
      ) : sinks.length === 0 ? (
        <TradeIdeasEmpty message="No delivery sinks configured yet." />
      ) : (
        <div className="space-y-6">
          <DeliverySinksTable
            sinks={sinks}
            statuses={statusQ.data?.delivery?.sinks ?? []}
            pending={upsertSink.isPending || deleteSink.isPending}
            onSave={(name, sink) => upsertSink.mutate({ name, sink })}
            onDelete={(name) => deleteSink.mutate(name)}
          />
          <OutboxTable
            items={outboxQ.data ?? []}
            status={outboxStatus}
            pending={retryOutbox.isPending}
            error={outboxQ.isError ? (outboxQ.error as Error).message : null}
            onStatusChange={setOutboxStatus}
            onRetry={() => retryOutbox.mutate()}
          />
        </div>
      )}
    </TradeIdeasPage>
  );
}
